import { ReturnActionType } from "../types/return-type";
import { SetButtonUpActionTypes } from "../types/button-up";

export const setButtonUp = (payload: boolean): ReturnActionType => ({
  type: SetButtonUpActionTypes.TOGGLE_BUTTON,
  payload,
});
